import { Row } from '@simplywallst/ui-core';
import {
  ValuationRatioWrapper,
  ValuationItemLabel,
  ValuationItemText,
  ValuationItemWrapper,
} from './styled';

interface Props {
  priceToEarnings: string;
  priceToBook: string;
  priceToSales: string;
}

interface ValuationItemProps {
  label?: string;
  text: string;
  value: string | undefined;
  unavailableText: string;
}

const ValuationItem = ({
  label,
  text,
  value,
  unavailableText,
}: ValuationItemProps) => (
  <ValuationItemWrapper>
    <ValuationItemLabel>
      {label}
      {label && '\u00A0\u00A0'}
      {value ? <strong>{value}</strong> : <span>{unavailableText}</span>}
    </ValuationItemLabel>
    <ValuationItemText>{text}</ValuationItemText>
  </ValuationItemWrapper>
);

export const ValuationRatio = ({
  priceToEarnings,
  priceToBook,
  priceToSales,
}: Props) => {
  return (
    <ValuationRatioWrapper>
      <ValuationItem
        label="PE"
        text="Price to Earnings"
        value={priceToEarnings !== 'n/a' ? priceToEarnings : undefined}
        unavailableText="n/a (not profitable)"
      />
      <Row alignItem="flex-end">
        <ValuationItem
          label="PB"
          text="Price to Book"
          value={priceToBook !== 'n/a' ? priceToBook : undefined}
          unavailableText="n/a"
        />
        <ValuationItem
          label="PS"
          text="Price to Sales"
          value={priceToSales !== 'n/a' ? priceToSales : undefined}
          unavailableText="n/a"
        />
      </Row>
    </ValuationRatioWrapper>
  );
};

interface GrowthTooltipProps {
  analystCount: number | null;
  earningsGrowth: string;
  salesGrowth: string;
}

export const GrowthTooltip = ({
  analystCount,
  earningsGrowth,
  salesGrowth,
}: GrowthTooltipProps) => {
  return (
    <ValuationRatioWrapper>
      {!!analystCount && (
        <span>
          Growth Forecasts from <strong>{analystCount} analysts</strong>
        </span>
      )}
      <Row alignItem="flex-end">
        <ValuationItem
          text="Earnings Growth"
          value={earningsGrowth}
          unavailableText="n/a"
        />
        <ValuationItem
          text="Sales Growth"
          value={salesGrowth}
          unavailableText="n/a"
        />
      </Row>
    </ValuationRatioWrapper>
  );
};
